// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__3zoAE","checkboxCol":"Table_checkboxCol__20VHa","emailCol":"Table_emailCol__2S29i","actionCol":"Table_actionCol__r7pFo"};